// These steps pass through params from https://docs.react-joyride.com/step

export const steps = [
  {
    disableBeacon: true,
    target:
      '[data-testid="scribephone-toggle-switch"][data-state="on"]',
    placement: "right",
    title: "Let's Create Your First Note",
    content:
      "First we need to switch from Scribephone to a regular recording.",
    eagerSkip: true,
    spotlightClicks: true,
    hideFooter: true,
  },
  {
    disableBeacon: true,
    target: '[data-testid="record-button"][data-callmode="false"]',
    placement: "right",
    title: "Let's Create Your First Note",
    content:
      "Scribenote works in the background while you run your appointment as usual! Don't worry, we'll filter out any chit-chat.",
  },
  {
    disableBeacon: true,
    title: "Click the Record Button",
    content:
      "Click the record button to start recording the appointment. You can do a mock appointment to start! \n\n In real cases, make sure to get consent from the client.",
    target: '[data-testid="record-button"][data-callmode="false"]',
    placement: "right",
    hideFooter: true,
    spotlightClicks: true,
    skipOnTargetLost: true,
  },
  {
    disableBeacon: true,
    target: '[data-testid="stop-button"]',
    placement: "right",
    title: "Collect History Details",
    content: `Let’s start by collecting a history.
  Who is here today, and what are they here for?
  What do they eat?
  Are they on any medications?
  Is there V/D/C/S?
  Any other concerns?`,
  },
  {
    disableBeacon: true,
    target: '[data-testid="stop-button"]',
    placement: "right",
    title: "Do a Physical Exam",
    content:
      "Let’s do a physical exam aloud with the owner. Start from nose to tail and say things the way you’d normally say them – “The heart sounds great, teeth look excellent, lymph nodes all feel normal.” Then throw some abnormals in as well.",
  },
  {
    disableBeacon: true,
    target: '[data-testid="stop-button"]',
    placement: "right",
    title: "Assess Your Findings",
    content:
      "Now let’s review findings and what they mean. Are you adding any tests or vaccines today?",
  },
  {
    disableBeacon: true,
    target: '[data-testid="stop-button"]',
    placement: "right",
    title: "Wrap Up Your Appointment",
    content:
      "Finally, include results if you’d like.\n\nAre you sending the pet home with any medications?\nAre you giving any vaccines – and how long are they good for?\nIs there a recheck you want booked?",
  },
  {
    disableBeacon: true,
    target: '[data-testid="stop-button"]',
    placement: "right",
    title: "Stop the Recording",
    content:
      "Great! Press the big Stop button when you're done your appointment. You'll see the magic in action as we take that appointment example, and turn it into a structured SOAP note!",
    spotlightClicks: true,
    hideFooter: true,
    skipOnTargetLost: true,
  },
  {
    disableBeacon: true,
    target: '[data-testid="dashboard-note-list"]',
    placement: "top",
    title: "View Your Notes",
    content:
      "Once your recording starts being processed into a note, it will appear here in your inbox. Wait for it to finish and then we can review it. It should only take a minute or two!",
    eagerSkip: true,
    hideFooter: true,
    abortTarget:
      '[data-testid="note-item-individual-container"]:first-child [data-testid*=note-item][data-note-statuses="retry"]',
    abortMessage:
      "Oh no, it looks like something went wrong! Why don't you try one more time.",
    waitIterations: 10,
  },
  {
    disableBeacon: true,
    target:
      '[data-testid="note-item-individual-container"]:first-child [data-testid*=note-item][data-note-statuses="review"]',
    title: "Review Your Note",
    content: "Click the note to open and review it!",
    spotlightClicks: true,
    hideFooter: true,
    skipOnTargetLost: true,
  },
  {
    disableBeacon: true,
    target: "body",
    placement: "center",
    title: "Review Your Note",
    disableOverlay: true,
    content:
      "Scroll through to review the sections of your note. This is our default SOAP note format, but Scribenote offers endless customization options!",
  },
  {
    disableBeacon: true,
    title: "View Templates",
    content:
      "Click this button to bring up the template selection menu. This is where you can change the note's template after it's been generated!",
    target: '[data-testid="new-use-template-button"]',
    spotlightClicks: true,
    hideFooter: true,
    eagerSkip: true,
    requiresAdaptiveTemplates: true,
  },
  {
    disableBeacon: true,
    title: "Change Template",
    content:
      "We've given you some sample templates to try out. This one was customized to provide more detailed normals in the Objective section, and a more structured Plan section. \n\n Click the template to apply it!",
    target: '[data-testid="template-item-general-practice-|-soap"]',
    placement: "right",
    spotlightClicks: true,
    isFixed: true,
    hideFooter: true,
    disableOverlay: true,
    skipOnTargetLost: true,
    requiresAdaptiveTemplates: true,
  },
  {
    disableBeacon: true,
    title: "Pre-Select Template",
    content:
      "You can also choose a template before you start recording your appointment by using this dropdown menu.",
    target: '[data-testid="record-templates-dropdown-button"]',
    placement: "top",
  },
  {
    disableBeacon: true,
    target: "body",
    title: "You're All Set!",
    content:
      "Customizing your note is easy with Scribenote, there are infinite options with templates like this!\n\n For now, we’ll let you keep exploring. Until next time! 🐾",
    placement: "center",
  },
];
